/**
 * Application Breadcrumb Configuration
 *
 * This file demonstrates how to configure breadcrumbs across the application.
 * Modify these settings to control breadcrumb behavior globally.
 */

// Global breadcrumb settings
export const BREADCRUMB_SETTINGS = {
  // Set to true to hide breadcrumbs across the entire application
  HIDE_ALL_BREADCRUMBS: false,

  // Set to true to hide breadcrumbs only on specific pages
  HIDE_ON_TRANSACTION_PAGES: false, // Make sure this is false to show breadcrumbs
  HIDE_ON_DASHBOARD: false,
  HIDE_ON_USER_PAGES: false,
  HIDE_ON_SETTINGS_PAGES: false,

  // Custom breadcrumb styles
  SHOW_HOME_ICON: true,
  SHOW_DIVIDERS: true,
  MAX_BREADCRUMB_ITEMS: 5,

  // Animation settings
  ENABLE_BREADCRUMB_ANIMATIONS: true,
  ANIMATION_DURATION: 200,
} as const;

// Page-specific breadcrumb configurations
export const PAGE_BREADCRUMB_CONFIG = {
  // Transaction pages
  '/transactions': {
    hideBreadcrumbs: BREADCRUMB_SETTINGS.HIDE_ON_TRANSACTION_PAGES,
    customTitle: 'Payment Transactions',
    showStats: true,
  },

  // Dashboard
  '/dashboard': {
    hideBreadcrumbs: BREADCRUMB_SETTINGS.HIDE_ON_DASHBOARD,
    customTitle: 'Overview',
  },

  // User management
  '/users': {
    hideBreadcrumbs: BREADCRUMB_SETTINGS.HIDE_ON_USER_PAGES,
    customTitle: 'User Management',
  },

  // Settings
  '/settings': {
    hideBreadcrumbs: BREADCRUMB_SETTINGS.HIDE_ON_SETTINGS_PAGES,
    customTitle: 'Application Settings',
  },
} as const;

/**
 * Utility function to get breadcrumb configuration for a specific page
 */
export const getBreadcrumbConfig = (pathname: string) => {
  // Check global setting first
  if (BREADCRUMB_SETTINGS.HIDE_ALL_BREADCRUMBS) {
    return { hideBreadcrumbs: true };
  }

  // Find page-specific configuration
  const pageConfig = PAGE_BREADCRUMB_CONFIG[pathname as keyof typeof PAGE_BREADCRUMB_CONFIG];

  return pageConfig || { hideBreadcrumbs: false };
};

/**
 * Hook to get breadcrumb configuration for current page
 */
export const useBreadcrumbConfig = (pathname: string) => {
  return getBreadcrumbConfig(pathname);
};

// Export types for TypeScript support
export type BreadcrumbSettings = typeof BREADCRUMB_SETTINGS;
export type PageBreadcrumbConfig = typeof PAGE_BREADCRUMB_CONFIG;

export default BREADCRUMB_SETTINGS;
